import React from 'react';
import { Logo } from './Logo';
import { Button } from './Button';
interface SiteHeaderProps {
  onSubscribeClick: () => void;
}
export function SiteHeader({
  onSubscribeClick
}: SiteHeaderProps) {
  return <header className="sticky top-0 z-30 w-full bg-wt-background-color/95 shadow-navbar backdrop-blur" data-id="element-28" data-mp="1nn669m045i0s">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-3 px-4 sm:px-6 lg:h-20 lg:px-8" data-id="element-29" data-mp="1iouuv6u66zgg">
        <a href="#top" className="flex min-w-0 items-center gap-2 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-wt-primary-color focus-visible:ring-offset-2 sm:gap-3" data-id="element-30" data-mp="uyr4w29wmy7x">
          <span className="shrink-0" data-id="element-31" data-mp="14uc1fkw7f6aa">
            <Logo size="md" data-id="element-32" data-mp="zwsm0hnrsngr" />
          </span>
          <span className="truncate whitespace-nowrap font-['Montserrat',ui-sans-serif,system-ui,sans-serif] text-[13px] font-bold text-black min-[400px]:text-sm sm:text-lg" data-id="element-33" data-mp="zw0pn4mcmlpf">
            Friends of Hayward Park
          </span>
        </a>
        <div className="shrink-0" data-id="element-34" data-mp="29k2c2l8opvx3">
          <Button size="sm" onClick={onSubscribeClick} data-id="element-35" data-mp="29isedx5qupqz">
            Subscribe
          </Button>
        </div>
      </div>
    </header>;
}